import { ceil } from 'lodash';

/**
 * get the next highest increment that is evenly divisible by the specificed value
 */
const nextHighest = (value: number, divisibleBy: number) =>
  ceil(ceil(value) / divisibleBy) * divisibleBy;

export default nextHighest;
